import http from '../../../common/utils/http'
import apiUtils from '../../../common/utils/apiUtils'
import {API_BASE_URL} from '../../../common/utils/commonUrl'

export default {
  getCouponByCouponUseStatus: (data) => {
    return http.get(`${API_BASE_URL}/api/wxoa/coupon/couponExample/getUserCouponListByMemberId`, {params: data}).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  },
  getUserReasonCouponListByMemberId: (data) => {
    return http.get(`${API_BASE_URL}/api/wxoa/coupon/couponExample/getUserReasonCouponListByMemberId`).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/wx-member/member-coupon/member-coupon.js